import React from 'react';

export interface HoverState {
  visible: boolean;
  message: string;
  left: number;
  top: number;
}

export const HoverTooltip: React.FC<HoverState> = ({
  visible,
  message,
  left,
  top,
}) => {
  if (!visible) return null;

  return (
    <div
      role="tooltip"
      className="pointer-events-none z-[9999] rounded px-2 py-1 text-xs text-white"
      style={{
        position: 'fixed',
        left,
        top,
        transform: 'translate(-50%, -100%)',
        backgroundColor: 'rgba(0,0,0,0.75)',
        whiteSpace: 'nowrap',
      }}
    >
      {message}
    </div>
  );
};
